function gtagV4(name, params = {}) {
  gtag('event', name, typeof params != 'object' ? { value: params } : params)
}
export default gtagV4
